import React, { useEffect, useState } from "react";
import { Col, Row, Button, Label } from "reactstrap";
import { textTranslate } from "../../utils/i18n";
import DatePicker from "react-datepicker";

const PopUpFiltering = (props) => {
  const { data } = props;
  const [originalData, setOriginalData] = useState(data); // store original data

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filterData, setFilterData] = useState(data);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleDateChange = (selectedOptions) => {
    if (Array.isArray(selectedOptions) && selectedOptions.length === 2) {
      const [start, end] = selectedOptions;
      setStartDate(start);
      setEndDate(end);
      console.log("start", start);
      console.log("end", end);

      filterDataBasedOnSelection({
        startDate: start,
        endDate: end,
      });
    } else {
      console.error("error", selectedOptions);
    }
  };

  const filterDataBasedOnSelection = (date) => {
    let start;
    let end;

    if (date && startDate && endDate) {
      setFilterData(originalData);

      props.onFilteredDevicesPopUpTable(start, end);
      return;
    }

    if (date) {
      console.log("Date", date);
      start = startDate;
      end = endDate;
    }

    props.onFilteredDevicesPopUpTable(date.startDate, date.endDate);

    // setFilterData(newFilteredData);
    // props.onFilteredDevices(newFilteredData);
  };

  return (
    <React.Fragment>
      <React.Fragment>
        {/* <Row className="mb-2 "> */}
        <Col sm="12" md="4" className="mt-1 d-flex flex-column">
          <Label className="text-muted mx-auto ">{textTranslate("select_date")}</Label>
          <div className="d-flex justify-content-center">
            <DatePicker
              className="btn btn-primary"
              dateFormat="dd/MM/yyyy"
              showIcon
              selectsRange
              startDate={startDate}
              endDate={endDate}
              onChange={(date) => handleDateChange(date)}
              isClearable
            />
          </div>
        </Col>
        {/* </Row> */}
      </React.Fragment>
    </React.Fragment>
  );
};

export default PopUpFiltering;
